import posthog from 'posthog-js';
import { safeException, type ErrorSource, type ReactErrorKind } from '../../shared/analytics-safety';
let enabled = false;
let preferenceVersion = 0;
let sent = 0;
const seen = new WeakSet<object>();
export function setErrorTrackingEnabled(value: boolean) { enabled = value; preferenceVersion++; }
export function reportBrowserError(error: unknown, source: ErrorSource, reactErrorKind?: ReactErrorKind) {
  if (!enabled || posthog.has_opted_out_capturing() || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl || sent >= 20) return;
  if (error && typeof error === 'object') {
    if (seen.has(error)) return;
    seen.add(error);
  }
  sent++;
  posthog.capture('$exception', { ...safeException(error, source, { route: window.location.pathname, reactErrorKind }), surface: 'web' });
}
export function startBrowserErrors() {
  window.addEventListener('error', (event) => { if (event.error) reportBrowserError(event.error, 'browser_unhandled'); });
  window.addEventListener('unhandledrejection', (event) => reportBrowserError(event.reason, 'browser_rejection'));
  const initialVersion = preferenceVersion;
  void fetch('/api/session', { credentials: 'same-origin', cache: 'no-store' }).then(async (r) => {
    if (preferenceVersion !== initialVersion) return;
    if (r.status === 401) enabled = true;
    else if (r.ok) {
      const session = await r.json() as { user?: { analyticsEnabled?: boolean } };
      if (preferenceVersion === initialVersion) enabled = session.user?.analyticsEnabled === true;
    }
  }).catch(() => { /* Unknown preference: no error telemetry. */ });
}
